import styled from 'styled-components'
import { useUserPendingActions } from '../../hooks'
import GoodSVG from '../../assets/status/good.svg?react'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '../../routes'
import { useEffect } from 'react'
import { useNavbar } from '../../contexts/NavbarContext'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

const PVTFinished = ({ done, pending }) => {
  const navigate = useNavigate()
  const { data } = useUserPendingActions()
  const { show } = useNavbar()
  const { t } = useTranslation('common')

  useEffect(() => {
    show()
  }, [])

  if (data?.intakePending) {
    setTimeout(() => {
      navigate(ROUTES.INTAKE)
    }, [3000])
  }

  return (
    <Container>
      <GoodSVG />
      <span style={{ fontSize: 32, fontWeight: 700 }}>
        {t('pvt.finished.done', { done: done })}
      </span>
      <span style={{ fontSize: 20 }}>
        {t('pvt.finished.pending', { pending: pending })} {pending > 1 ? t('pvt.finished.plural_test') : t('pvt.finished.test')} {t('pvt.finished.pending_end')}
      </span>
      {data?.intakePending && (
        <span style={{ marginTop: 24, fontSize: 22 }}>
          {t('pvt.finished.intake_pending')}
        </span>
      )}
    </Container>
  )
}

export default PVTFinished
